<template>

    <Modal :idModal="idModal" :headerTitle="headerTitle" modalSize="modal-xl" >
        <div class="directory-user-modal-form">
            <div class="form-group">
                <label>{{ $t('User Type') }}</label>
                <select class="form-select" v-model="createType" >
                    <option value="1">{{ $t('Existing') }}</option>
                    <option value="2"> {{ $t('New') }}</option>
                </select>
            </div>
            <template v-if="createType==1">
                <div class="form-group">
                    <label>{{ $t('Company Type') }} <span v-if="IsMissingRequired(existing.companyType)" class="directory-required-tag">({{ $t('required') }})</span></label>
                    <select class="form-select" v-model="existing.companyType" @change="ChangeExistingCType">
                        <option v-for="(item, key) in CompanyTypeList" :key="key" :value="item.id">{{item.value}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>{{ $t('User') }} <span v-if="IsMissingRequired(existing.userId)" class="directory-required-tag">({{ $t('required') }})</span></label>
                    <Select2 
                        :filterQuery="SearchUser"
                        indexValue="_id"
                        labelName="fullname"
                        :placeHolder="$t('Search Contact Name')"
                        v-model:optionValue="existing.userId"
                        :onOptionClick="AppendSelectedInfo"
                        ref="select2UserExist"
                    ></Select2>
                </div>
                 <div class="form-group" v-if="existing.companyType==CompanyType.MMOSER">
                <label>{{ $t('Role in Project') }} <span v-if="IsMissingRequired(existing.roleId)" class="directory-required-tag">({{ $t('required') }})</span></label>
                    <select class="form-select" v-model="existing.roleId">
                    <option value="">{{ $t('Please Select') }}</option>
                    <option v-for="(item, key) in roles" :key="key" :value="item._id">{{$t(item.roleName)}}</option>
                </select>
            </div>
                <div class="form-group"  v-if="existing.companyType!=CompanyType.MMOSER">
                    <label>{{ $t('Role in Project') }} <span v-if="IsMissingRequired(existing.roleProject)" class="directory-required-tag">({{ $t('required') }})</span></label>
                    <input type="text" class="form-control" placeholder="Project Leader" v-model="existing.roleProject"  readonly  />
                </div>
                <div class="form-group" >
                    <label>{{ $t('Job Description') }} <span v-if="IsMissingRequired(existing.jobDescription)" class="directory-required-tag">({{ $t('required') }})</span></label>
                    <input type="text" class="form-control" :placeholder="$t('Job Description')" v-model="existing.jobDescription" />
                </div>
            </template>
            <template v-else>
                <div class="form-group">
                    <label>{{ $t('Company Type') }} <span v-if="IsMissingRequired(newUser.companyType)" class="directory-required-tag">({{ $t('required') }})</span></label>
                    <select class="form-select" v-model="newUser.companyType" @change="ChangeNewUserCtype">
                        <option v-for="(item, key) in CompanyTypeList" :key="key" :value="item.id">{{item.value}}</option>
                    </select>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ $t('First Name') }} <span v-if="IsMissingRequired(newUser.firstName)" class="directory-required-tag">({{ $t('required') }})</span></label>
                            <input type="text" class="form-control" :placeholder="$t('First Name')" v-model="newUser.firstName" />
                        </div>
                        <div class="form-group">
                            <label>{{ $t('Last Name') }} <span v-if="IsMissingRequired(newUser.lastName)" class="directory-required-tag">({{ $t('required') }})</span></label>
                            <input type="text" class="form-control" :placeholder="$t('Last Name')" v-model="newUser.lastName" />
                        </div>
                        <div class="form-group" v-if="newUser.companyType==CompanyType.MMOSER">
                            <label>{{ $t('Role in Project') }} <span v-if="IsMissingRequired(newUser.roleId)" class="directory-required-tag">({{ $t('required') }})</span></label>
                             <select class="form-select" v-model="newUser.roleId">
                                <option value="">{{ $t('Please Select') }}</option>
                                <option v-for="(item, key) in roles" :key="key" :value="item._id">{{$t(item.roleName)}}</option>
                            </select>
                        </div>
                        <div class="form-group"  v-else-if="newUser.companyType==CompanyType.CLIENT">
                            <label>{{ $t('Role in Project') }}</label>
                            <input type="text" class="form-control" readonly value="Client" />
                        </div>
                        <div class="form-group"  v-else>
                            <label>{{ $t('Role in Project') }} <span v-if="IsMissingRequired(newUser.roleProject)" class="directory-required-tag">({{ $t('required') }})</span></label>
                            <input type="text" class="form-control" :placeholder="$t('Role in Project')" readonly v-model="newUser.roleProject" />
                        </div>
                        <div class="form-group">
                            <label>{{ $t('Job Description') }} <span v-if="IsMissingRequired(newUser.jobDescription)" class="directory-required-tag">({{ $t('required') }})</span></label>
                            <input type="text" class="form-control" :placeholder="$t('Job Description')" v-model="newUser.jobDescription" />
                        </div>
                        <div class="form-group">
                            <label>{{ $t('Email') }} <span v-if="IsMissingRequired(newUser.email)" class="directory-required-tag">({{ $t('required') }})</span></label>
                            <input
                                type="email"
                                class="form-control"
                                :class="{ 'is-invalid': SaveClicked && !IsValidEmail(newUser.email) }"
                                placeholder="sample@gmail.com"
                                v-model.trim="newUser.email"
                            />
                            <small class="directory-field-error" v-if="SaveClicked && !IsMissingRequired(newUser.email) && !IsValidEmail(newUser.email)">{{ $t('Enter a valid email address') }}</small>
                        </div>
                        <div class="form-group" v-if="newUser.companyType!=CompanyType.MMOSER && !IsNewCompany">
                            <label>{{ $t('Company Name') }} <span v-if="IsMissingRequired(newUser.company)" class="directory-required-tag">({{ $t('required') }})</span></label>
                            <!-- <input type="text" class="form-control" placeholder="Company Name" v-model="newUser.company" /> -->
                            <Select2 
                            :filterQuery="SearchCompanies"
                            indexValue="_id"
                            labelName="companyName"
                            :placeHolder="$t('Search Company')"
                            ref="select2UsercompanyUpdate"
                            v-model:optionValue="newUser.company"
                            ></Select2>
                            <a class="text-primary small" role="button" @click="ToggleCompanyMode">{{ $t('Not able to Find Company? Click here to create')}}</a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ $t('Address') }}</label>
                            <textarea class="form-control" v-model="newUser.address" :placeholder="$t('Address')"></textarea> 
                        </div>
                        <div class="form-group" v-for="(item, key) in addedContacts" :key="key">
                            <div class="d-flex justify-content-between">
                                <label> {{ $t('Contact Number') }}</label>
                                <small v-if="key!=0" @click="RemoveContact(key)" class="directory-contact-remove" role="button"><i class="fa-solid fa-minus"></i> {{ $t('Remove') }}</small>
                            </div>
                            <input type="tel" inputmode="tel" class="form-control" placeholder="+6312345678910" v-model="item.value" @input="FilterContactNumber(item, $event)" @change="ChangeContact(key,$event.target.value)" />
                        </div>
                        <div>
                            <small @click="AddNewLineContact" class="text-primary" role="button"><i class="fa-solid fa-plus"></i> {{ $t('Add Contact Number') }}</small>
                        </div>
                        
                    </div>
                </div>
                <div class="row" v-if="IsNewCompany">
                    <div class="col-md-6" >
                        <div class="form-group">
                            <label>{{ $t('Company Name') }} <span v-if="IsMissingRequired(newUser.client_company)" class="directory-required-tag">({{ $t('required') }})</span></label>
                            <input type="text" class="form-control"  v-model="newUser.client_company"  :placeholder="$t('Company Name')"
                            />
                            <a class="text-primary small" role="button" @click="ToggleCompanyMode">{{ $t('Choose Existing Company? Click Here') }}</a>
                        </div>
                    </div>
                    <div class="col-md-6" >
                        <div class="form-group">
                            <label>{{ $t('Company Address') }} <span v-if="IsMissingRequired(newUser.client_company_address)" class="directory-required-tag">({{ $t('required') }})</span></label>
                            <textarea class="form-control" v-model="newUser.client_company_address" :placeholder="$t('Company Address')"></textarea>
                        </div>
                    </div>
                </div>
                
                
            </template>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeDirModal" :disabled="isSaving" class="btn btn-outline-danger" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <div class="directory-save-dropdown dropdown">
                <button type="button" class="directory-save-main" @click="SaveNew" :disabled="isSaving" :aria-busy="isSaving">
                    <span v-if="isSaving" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span><i v-else class="fas fa-save"></i> {{ isSaving ? "Saving…" : $t("Save") }}
                </button>
                <button type="button" class="directory-save-toggle dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false" :disabled="isSaving">
                    <span class="visually-hidden">{{ $t('Save') }}</span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end directory-save-menu">
                    <li>
                        <button class="dropdown-item" type="button" @click="SaveAndClose" :disabled="isSaving">
                            <i class="fas fa-save"></i> {{ $t('Save and Close') }}
                        </button>
                    </li>
                </ul>
            </div>
        </template>
    </Modal>
</template>


<script>
import Modal from '@/components/layout/Modal.vue'
import Select2 from '@/components/layout/Select2.vue'
import {CompanyTypeList, CompanyType, IsValidEmail} from '@/helpers/utilities.js'
import {SearchUserDirectory, SearchCompanies} from '@/actions/directoryActions.js'
import {AddNewToProjectDirectory, AddToProjectDirectory, SearchUserFromKC} from '@/actions/projectActions.js'
import {mapActions}  from 'vuex'

import  i18n from '@/translations/i18n.js'
const i18nTranslate = i18n.global.t
export default {
    name : 'CreateModalUser',
    props : ['idModal', 'headerTitle','SetList', 'roleList'],
    components : {
        Modal,
        Select2
    },
    computed : {
        roles(){
            return this.roleList
        }
    },
    methods : {
        FilterContactNumber(item, event){
            const input = event.target
            const clean = value => value.replace(/[^0-9+ ()-]/g, '').replace(/(?!^)\+/g, '')
            const cursor = input.selectionStart
            const beforeCursor = cursor == null ? null : clean(input.value.slice(0, cursor)).length
            const value = clean(input.value)
            item.value = value
            if (input.value !== value) {
                input.value = value
                if (beforeCursor != null) input.setSelectionRange(beforeCursor, beforeCursor)
            }
        },
        IsValidContactNumber(value){
            return typeof value === 'string' && (!value.trim() || /^\+?[0-9 ()-]+$/.test(value.trim()) && /[0-9]/.test(value));
        },

        ...mapActions(['GetProjectDirectory']),
        IsValidEmail (value){
            return IsValidEmail(value)
        },
        IsMissingRequired(value){
            return value === null || typeof value === 'undefined' || String(value).trim() === ''
        },
        ExtractDirectoryErrorMessage(error){
            if(typeof error === 'string'){
                return error
            }
            if(!error || typeof error !== 'object'){
                return ''
            }

            return error.error?.message || error.message || error.detail || ''
        },
        ShowDirectorySaveError(error){
            const self = this
            const reason = self.ExtractDirectoryErrorMessage(error)
            const isSavedSyncFailure = Boolean(error && typeof error === 'object' && error.saved)
            const wasSynchronized = Boolean(isSavedSyncFailure && error.synchronized === true)
            const emailWasNotFound = reason.toLowerCase().includes('email does not exist')

            if(isSavedSyncFailure){
                const message = wasSynchronized
                    ? `${i18nTranslate('The user was added to the Project Directory and synchronized with LENS, but a follow-up notification or email operation failed. Do not add the user again.')} ${reason ? `${i18nTranslate('Reason')}: ${reason}` : ''}`.trim()
                    : emailWasNotFound
                    ? i18nTranslate('The user was added to the Project Directory, but the email address could not be verified in LENS. Please verify the email address or contact an administrator. Do not add the user again.')
                    : `${i18nTranslate('The user was added to the Project Directory, but synchronization with LENS failed. Do not add the user again.')} ${reason ? `${i18nTranslate('Reason')}: ${reason}` : ''}`.trim()

                self.GetProjectDirectory(1).then(()=>self.SetList()).catch(()=>{})
                return self.$swal({
                    title: wasSynchronized
                        ? i18nTranslate('User synchronized, but follow-up failed')
                        : emailWasNotFound
                        ? i18nTranslate('LENS synchronization incomplete')
                        : i18nTranslate('User saved, but LENS sync failed'),
                    text: message,
                    icon: 'warning',
                    confirmButtonText: i18nTranslate('Close')
                }).then(()=>{
                    self.$refs.closeDirModal.click()
                })
            }

            return self.$swal({
                title: i18nTranslate('Unable to add user'),
                text: reason || i18nTranslate('The user could not be added. Please try again or contact an administrator.'),
                icon: 'warning',
                confirmButtonText: i18nTranslate('Close')
            })
        },
        SearchUser(search){
            return SearchUserDirectory(search,"0", this.existing.companyType)
        },
        SearchFromKc(search){
            return SearchUserFromKC(search)
        },
        SearchCompanies(search){
            return SearchCompanies({search : search})
        },
        AddNewLineContact(){
            this.addedContacts.push({value : ''})
        },
        RemoveContact(key){
            this.addedContacts.splice(key,1)
            this.newUser.contacts.splice(key,1)
        },
        ChangeExistingCType(){
            this.$refs.select2UserExist.ClearData()
            this.$refs.select2UserExist.searchExe()
            this.existing.roleProject = CompanyTypeList[this.existing.companyType - 1].value
        },
        ChangeNewUserCtype(){
            this.newUser.roleProject = CompanyTypeList[this.newUser.companyType - 1].value
        },
        AppendSelectedInfo(data){
            this.existing.company = data.company
        },
        AppendSelectedKcUser(data){
            this.newUser.firstName = data.firstName
            this.newUser.lastName = data.lastName
            this.newUser.photoUrl = data.photo
            this.newUser.email = data.email
            this.addedContacts = [{value : ''}]
            this.newUser.contacts  = []
            if(data.mobileNo!=""){
                this.addedContacts[0].value = data.mobileNo
                this.newUser.contacts.push(data.mobileNo)
            }
        },
        SaveNew(e){ return this.SaveDirectory(e, false) },
        async SaveDirectory(e, closeAfterSave){
            if (this.isSaving) return
            this.isSaving = true
            let result
            try {
                result = this.createType == 1 ? await this.SaveExistingToDirectory(e) : await this.SaveExe(e)
                if (result && result !== 'OK') this.ShowDirectorySaveError(result)
            } catch (error) {
                this.ShowDirectorySaveError('Could not finish saving. Please try again.')
            } finally {
                this.isSaving = false
            }
            if (result === 'OK' && closeAfterSave) {
                await this.$nextTick()
                this.$refs.closeDirModal.click()
            }
        },
        ToggleCompanyMode(){
            this.IsNewCompany = !this.IsNewCompany
            this.SaveClicked = false
            if(this.IsNewCompany){
                this.newUser.company = ''
            }else{
                this.newUser.client_company = ''
                this.newUser.client_company_address = ''
            }
        },
        SaveAndClose(e){ return this.SaveDirectory(e, true) },
        SaveExistingToDirectory(){
            const self = this
            return new Promise((resolve)=>{
                // Loading is managed by SaveDirectory.
                self.SaveClicked = true
                if(!self.existing.userId){
                    return resolve(false)
                }
                const { companyType, jobDescription, roleId} = self.existing

                if(companyType==CompanyType.MMOSER){
                    if(!companyType || !jobDescription ||!roleId ){
                        return resolve(false)
                    }
                }
                else{
                    if(!companyType  || !jobDescription ){
                        return resolve(false)
                    }
                }
                self.SaveClicked = false
                
                AddToProjectDirectory(self.existing).then((res)=>{
                    if(res=="OK"){
                        self.existing = {
                            id : this.$route.params.id,
                            companyType : companyType,
                            roleId : ''
                        }
                        
                        self.$swal(i18nTranslate('Add User to Directory'), i18nTranslate('User Added to directory Successfully'), 'success')
                        return self.GetProjectDirectory(1).then(()=>{
                            self.SetList()
                            resolve(res)
                        }).catch(()=>resolve('The contact was saved, but the directory could not refresh. Please refresh this page.'))
                    }else{
                        resolve(res)
                    }
                    
                }).catch(()=>resolve('Could not finish saving. Please try again.'))
            })
        },
        SaveExe(){
            const self = this
            return new Promise((resolve)=>{
                // Loading is managed by SaveDirectory.
                self.SaveClicked = true
                if (self.addedContacts.some(item => !self.IsValidContactNumber(item.value))) return resolve(false)
                const { companyType, company, firstName, lastName, roleId, jobDescription, email, client_company, client_company_address} = self.newUser

                if(companyType==CompanyType.MMOSER){
                    if(!companyType || !firstName || !lastName || !roleId  || !jobDescription || !IsValidEmail(email) ){
                        return resolve(false)
                    }
                }
                else if(companyType==CompanyType.CLIENT){
                    if(!companyType ||  !firstName || !lastName  || !jobDescription || !IsValidEmail(email) ){
                        return resolve(false)
                    }
                }else{
                    if(!companyType || !firstName || !lastName  || !jobDescription || !IsValidEmail(email) ){
                        return resolve(false)
                    }
                }

                if(companyType!=CompanyType.MMOSER){
                    if(self.IsNewCompany){
                        if(!client_company || !client_company_address){
                            return resolve(false)
                        }
                    }else{
                        if(!company){
                            return resolve(false)
                        }
                    }
                }


                self.newUser.contacts = self.addedContacts.map(item => item.value.trim()).filter(Boolean)
                self.newUser.projectId = self.$route.params.id
                AddNewToProjectDirectory(self.newUser).then((res)=>{
                    self.SaveClicked = false
                    if(res=="OK"){
                        self.newUser = {
                            companyType : self.newUser.companyType,
                            roleId : '',
                            contacts : [''],
                            roleProject : self.newUser.roleProject
                        }

                        console.log(self.newUser, 'herere')
                        self.addedContacts = [{value : ''}]
                        self.$swal(i18nTranslate('Add User to Directory'), 'User Added to directory Successfully', 'success')
                        return self.GetProjectDirectory(1).then(()=>{
                            self.SetList()
                            resolve(res)
                        }).catch(()=>resolve('The contact was saved, but the directory could not refresh. Please refresh this page.'))
                    }
                    resolve(res)
                }).catch(()=>resolve('Could not finish saving. Please try again.'))

            })
        },
        ChangeContact(key,value){
            if(typeof this.newUser.contacts[key]==='undefined'){
                this.newUser.contacts.push(value)
            }else{
                this.newUser.contacts[key] = value
            }
        },
        OpenModal(){
            this.SaveClicked = false
            this.createType = 1
            if(this.$refs.select2UserExist){
                this.$refs.select2UserExist.ClearData()
            }
            this.existing = {
                id : this.$route.params.id,
                companyType : 1,
                roleId : ''
            }
            this.newUser = {
                companyType :  1,
                roleId : '',
                contacts : ['']
            }
            this.IsNewCompany = false
            this.addedContacts = [{value : ''}]
        }
    },
    data(){
        return{
            newUser : {
                companyType : '1',
                roleId : '',
                contacts : ['']
            },
            addedContacts : [{value : ''}],
            isSaving : false,
            SaveClicked : false,
            CompanyTypeList : CompanyTypeList,
            createType: 1,
            existing : {
                id : this.$route.params.id,
                companyType : 1,
            },
            CompanyType : CompanyType,
            IsNewCompany : false,
            ClientCompanyList : [],
        }
    }

}
</script>

<style scoped>
.directory-user-modal-form {
    display: block;
}

.directory-user-modal-form .form-group {
    margin-bottom: 1rem;
}

.directory-user-modal-form label {
    display: flex;
    min-height: 1rem;
    align-items: baseline;
    gap: 0.25rem;
    margin-bottom: 0.35rem;
    color: #27241f;
    font-size: 0.84rem;
    font-weight: 800;
}

.directory-user-modal-form .row {
    --bs-gutter-x: 1.35rem;
}

.directory-required-tag {
    color: #ff0000;
    font-size: 0.82em;
    font-weight: 800;
}

.directory-user-modal-form .form-control,
.directory-user-modal-form .form-select,
.directory-user-modal-form :deep(.select2-design) {
    min-height: 2.55rem;
    border: 1px solid #d7e0da;
    border-radius: 5px;
    color: #1f241f;
    background-color: #ffffff;
    box-shadow: none;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.directory-user-modal-form .form-control:focus,
.directory-user-modal-form .form-select:focus,
.directory-user-modal-form :deep(.select2-design:focus) {
    border-color: #298969;
    box-shadow: 0 0 0 3px rgba(41, 137, 105, 0.14);
}

.directory-user-modal-form .form-control.is-invalid {
    border-color: #d92525;
    background-image: none;
}

.directory-field-error {
    display: block;
    margin-top: 0.3rem;
    color: #c52222;
    font-size: 0.74rem;
    font-weight: 700;
    line-height: 1.3;
}

.directory-user-modal-form .form-control::placeholder,
.directory-user-modal-form :deep(.select2-design::placeholder) {
    color: #7d8983;
}

.directory-user-modal-form textarea.form-control {
    min-height: 5.5rem;
    resize: vertical;
}

.directory-user-modal-form .text-primary.small,
.directory-user-modal-form .text-warning {
    font-weight: 700;
}

.directory-contact-remove {
    color: #d92525;
    font-weight: 800;
}

.directory-contact-remove:hover,
.directory-contact-remove:focus {
    color: #b61717;
}

:global(#AddToDirectory .modal-dialog) {
    max-width: min(64rem, calc(100vw - 3rem));
}

:global(#AddToDirectory .modal-content) {
    border: 0;
    border-radius: 6px;
    box-shadow: 0 1.2rem 3rem rgba(30, 27, 22, 0.26);
    overflow: visible;
}

:global(#AddToDirectory .modal-header) {
    align-items: center;
    padding: 1.15rem 1.35rem;
    border-bottom: 1px solid #dde5df;
    background: #ffffff;
}

:global(#AddToDirectory .modal-title) {
    color: #1e1b16;
    font-size: 1.28rem;
    font-weight: 800;
}

:global(#AddToDirectory .btn-close) {
    opacity: 0.55;
}

:global(#AddToDirectory .btn-close:hover) {
    opacity: 0.9;
}

:global(#AddToDirectory .modal-body) {
    padding: 1.15rem 1.35rem;
    background: #fbfcfb;
}

:global(#AddToDirectory .modal-footer) {
    padding: 1rem 1.35rem;
    border-top: 1px solid #dde5df;
    background: #ffffff;
}

:global(#AddToDirectory .modal-footer .btn) {
    min-width: 8.75rem;
    min-height: 2.45rem;
    border-radius: 0;
    font-size: 0.86rem;
    font-weight: 800;
}

:global(#AddToDirectory .modal-footer .btn-outline-danger) {
    border-color: #dddddd;
    color: #1f241f;
    background: #dddddd;
}

:global(#AddToDirectory .modal-footer .btn-outline-danger:hover) {
    border-color: #cfcfcf;
    background: #cfcfcf;
}

:global(#AddToDirectory .modal-footer .btn-primary) {
    border-color: #173d78;
    background: #173d78;
}

:global(#AddToDirectory .modal-footer .btn-primary:hover) {
    border-color: #102b55;
    background: #102b55;
}

.directory-save-dropdown {
    position: relative;
    display: inline-flex;
    align-items: stretch;
}

.directory-save-main,
.directory-save-toggle {
    min-height: 2.45rem;
    border: 1px solid #ff6126;
    color: #ffffff;
    background: #ff6126;
    font-size: 0.86rem;
    font-weight: 800;
    line-height: 1;
}

.directory-save-main {
    min-width: 7.25rem;
    border-radius: 4px 0 0 4px;
    padding: 0.65rem 1.15rem;
}

.directory-save-toggle {
    width: 2.75rem;
    border-left-color: rgba(255, 255, 255, 0.32);
    border-radius: 0 4px 4px 0;
    box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.2);
}

.directory-save-main:hover,
.directory-save-toggle:hover,
.directory-save-main:focus,
.directory-save-toggle:focus {
    border-color: #ed541d;
    background: #ed541d;
}

.directory-save-toggle::after {
    margin-left: 0;
    border-top: 0;
    border-right: 0.3em solid transparent;
    border-bottom: 0.3em solid;
    border-left: 0.3em solid transparent;
    vertical-align: 0.12em;
}

.directory-save-toggle[aria-expanded="true"]::after {
    border-top: 0.3em solid;
    border-bottom: 0;
}

.directory-save-menu {
    min-width: 10rem;
    margin-top: 0.2rem !important;
    border: 0;
    border-radius: 4px;
    padding: 0;
    background: #ff6126;
    box-shadow: 0 0.7rem 1.5rem rgba(30, 27, 22, 0.18);
    overflow: hidden;
}

.directory-save-menu .dropdown-item {
    display: flex;
    min-height: 2.45rem;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;
    color: #ffffff;
    background: #ff6126;
    font-size: 0.84rem;
    font-weight: 800;
}

.directory-save-menu .dropdown-item:hover,
.directory-save-menu .dropdown-item:focus {
    color: #ffffff;
    background: #ed541d;
}
</style>
